import { z } from 'zod';

// VITE_API_URL accepts either an absolute URL (cross-origin direct calls)
// or a path-relative prefix like "/api" (same-origin via Pages Function proxy
// — needed so Safari treats the session cookie as first-party).
const envSchema = z.object({
  VITE_API_URL: z
    .string()
    .min(1)
    .refine(
      (v) => v.startsWith('http://') || v.startsWith('https://') || v.startsWith('/'),
      { message: 'VITE_API_URL must be absolute https:// URL or path-relative starting with "/"' },
    ),
  VITE_WS_URL: z.string().min(1),
});

export const env = envSchema.parse(import.meta.env);
